import { isEmpty } from "@commonUtils"

const parseGADetails = (gaObject) => {
    if (typeof gaObject === "object" && gaObject !== null) {
        const { action = "", label = "", category = "" } = gaObject
        return { action, label, category }
    } else return null
}

export const parseWidgetData = (response) => {
    const widgets = []
    const onPageLoadGA = response?.on_page_load_ga
    const pageTitle = response?.title
    let bannerImage = response?.banner_image
    const blurBanner = bannerImage?.url ? false : true
    const offerType = response?.offer_type
    const isOfferLocked = response?.locked_offer

    response?.widgets?.map?.((widget) => {
        let data
        const widgetData = widget?.data

        switch (widget?.type) {
            case "partner_offer_info":
                data = {
                    header: widgetData?.header,
                    subHeader: widgetData?.sub_header,
                    name: widgetData?.name,
                    icon: {
                        src: widgetData?.icon?.url,
                        alt: widgetData?.icon?.alt,
                    },
                    tag: {
                        text: widgetData?.tag?.text,
                        color: widgetData?.tag?.color,
                        backgroundColor: widgetData?.tag?.bg_color,
                    },
                    backgroundColor: widgetData?.bg_color,
                    offerType,
                    isOfferLocked,
                    lockedOfferInfo: {
                        backgroundColor: widgetData?.locked_offer?.bg_color,
                        placeholder: widgetData?.locked_offer?.placeholder,
                        subHeader: widgetData?.locked_offer?.sub_header,
                    },
                    unlockedOfferInfo: !isEmpty(widgetData?.unlocked_offer)
                        ? {
                              backgroundColor: widgetData?.unlocked_offer?.bg_color,
                              code: widgetData?.unlocked_offer?.code,
                              cta: {
                                  label: widgetData?.unlocked_offer?.cta?.label,
                                  icon: widgetData?.unlocked_offer?.cta?.icon,
                                  type: widgetData?.unlocked_offer?.cta?.type,
                                  functionMap: widgetData?.unlocked_offer?.cta?.function_map,
                                  gaDetails: parseGADetails(widgetData?.unlocked_offer?.cta?.ga_details),
                              },
                          }
                        : null,
                }
                bannerImage = bannerImage?.url ? bannerImage : widgetData?.icon
                widgets.push({ type: "partnerOfferInfo", widgetData: data })
                break
            case "how_to_avail":
                data = {
                    header: widgetData?.header?.text,
                    listItems: widgetData?.list_items,
                    listType: widgetData?.list_type,
                    cta: {
                        gaDetails: parseGADetails(widgetData?.cta?.ga_details),
                    },
                    functionMap: widgetData?.cta?.function_map,
                }
                widgets.push({ type: "howToAvail", widgetData: data })
                break
            case "terms_conditions":
                data = {
                    header: widgetData?.header?.text,
                    listItems: widgetData?.list_items,
                    listType: widgetData?.list_type,
                    cta: {
                        gaDetails: parseGADetails(widgetData?.cta?.ga_details),
                    },
                    functionMap: widgetData?.cta?.function_map,
                }
                widgets.push({ type: "termsAndConditions", widgetData: data })
                break
            case "faqs":
                data = {
                    header: widgetData?.header?.text,
                    listType: widgetData?.list_type,
                    listItems: widgetData?.data?.map((item) => {
                        return { label: item?.title, responses: [{ displayText: item?.content }] }
                    }),
                    questionCta: {
                        gaDetails: parseGADetails(widgetData?.faq_ga_details),
                    },
                    cta: {
                        gaDetails: parseGADetails(widgetData?.cta?.ga_details),
                    },
                    functionMap: widgetData?.cta?.function_map,
                }
                widgets.push({ type: "faqs", widgetData: data })
                break
            case "need_help":
                data = {
                    header: widgetData?.header,
                    subHeader: widgetData?.sub_header,
                    cta: {
                        label: widgetData?.cta?.label,
                        type: widgetData?.cta?.type,
                        action: widgetData?.cta?.action,
                        url: widgetData?.cta?.url?.web,
                        gaDetails: parseGADetails(widgetData?.cta?.ga_details),
                    },
                }
                widgets.push({ type: "needHelp", widgetData: data })
                break
            case "slide_unlock_offer":
                data = {
                    offerType,
                    isOfferLocked,
                    cta: {
                        functionMap: widgetData?.cta?.function_map,
                        gaDetails: parseGADetails(widgetData?.cta?.locked_info?.ga_details),
                        lockedInfo: {
                            text: widgetData?.cta?.locked_info?.text,
                            backgroundColor: widgetData?.cta?.locked_info?.bg_color,
                            color: widgetData?.cta?.locked_info?.color,
                            icon: {
                                src: widgetData?.cta?.locked_info?.icon?.url,
                                alt: widgetData?.cta?.locked_info?.icon?.alt,
                            },
                        },
                        unlockedInfo: {
                            text: widgetData?.cta?.unlocked_info?.title?.text,
                            backgroundColor: widgetData?.cta?.unlocked_info?.bg_color,
                            color: widgetData?.cta?.unlocked_info?.title?.color,
                            icon: {
                                src: widgetData?.cta?.unlocked_info?.icon?.url,
                                alt: widgetData?.cta?.unlocked_info?.icon?.alt,
                            },
                        },
                    },
                    redeemCta: !isEmpty(widgetData?.redeem_cta)
                        ? {
                              label: widgetData?.redeem_cta?.label,
                              icon: {
                                  src: widgetData?.redeem_cta?.icon?.url,
                                  alt: widgetData?.redeem_cta?.icon?.alt,
                              },
                              type: widgetData?.redeem_cta?.type,
                              action: widgetData?.redeem_cta?.action,
                              url: widgetData?.redeem_cta?.url?.web,
                              gaDetails: parseGADetails(widgetData?.redeem_cta?.ga_details),
                          }
                        : null,
                }
                widgets.push({ type: "unlockOffer", widgetData: data })
                break
        }
    })

    return {
        widgets,
        pageTitle,
        bannerImage,
        blurBanner,
        onPageLoadGA,
        isOfferLocked,
        offerType,
    }
}
